import React, { useEffect, useState, Fragment } from "react";
import Fade from "@material-ui/core/Fade";
import { CircularProgress } from "@material-ui/core";
import Firebase from "../../firebasehelper";
import ImageUpload from "../../components/ContentUpload/ImageUpload";
import "./TokenPotModal.css";

const TokenPotModal = ({ onSave, data }) => {
  const [loading, setLoading] = useState(false);
  const [tokenPotData, setTokenPotData] = useState({});
  useEffect(() => {
    if (data) {
      setTokenPotData({ ...data });
    }
  }, [data]);
  const updatePotName = ({ target }) => {
    setTokenPotData({ ...tokenPotData, name: target.value });
  };
  const uploadContent = async (mediaContent) => {
    const uploadFolder = "pots";
    const title = new Date().getTime().toString();
    setLoading(true);
    let img_url = await Firebase.uploadImage(
      mediaContent,
      title,
      uploadFolder + "/images"
    );
    setLoading(false);
    setTokenPotData({ ...tokenPotData, img: img_url });
  };
  return (
    <div
      className="modal fade token-pot-modal"
      id="token-pot-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Pot Configuration</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1">
            <div
              style={{
                marginBottom: 10,
              }}
            >
              <h5 className="section-title">Pot Name</h5>
              <input
                className="form-control form-control-md "
                placeholder="Input token pot name here..."
                onChange={updatePotName}
                value={tokenPotData.name}
              />
              <h5 className="section-title">Image</h5>
              <ImageUpload
                onChangeContent={uploadContent}
                contentUrl={tokenPotData.img}
              />
            </div>
          </div>
          <Fade
            in={loading}
            style={{
              transitionDelay: loading ? "800ms" : "0ms",
            }}
            unmountOnExit
          >
            <CircularProgress />
          </Fade>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-orange"
              data-dismiss="modal"
            >
              Later
            </button>
            <button
              type="button"
              className="btn btn-green"
              data-dismiss="modal"
              disabled={!tokenPotData.name || !tokenPotData.img}
              onClick={() => onSave(tokenPotData)}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TokenPotModal;



// WEBPACK FOOTER //
// ./src/screens/TokensAndPots/TokenPotModal.js